import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BrowserBarcodeReader } from "@zxing/library";

@Component({
  selector: "common-barcode-scanner",
  templateUrl: "./barcode-scanner.component.html",
  styleUrls: ["./barcode-scanner.component.scss"],
})
export class BarcodeScannerComponent {
  @Input() rt: string;
  @Input() barcodeValue: string;
  @Output() barcodeChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() onBlur: EventEmitter<string> = new EventEmitter<string>(); // since you are able to type stuff and not use the barcode we need this extra output parameter for onblur

  private codeReader: any;
  scannerStarted: boolean = false;

  constructor() {}

  start() {
    this.scannerStarted = true;
    this.codeReader = new BrowserBarcodeReader();
    this.codeReader
      .decodeOnceFromVideoDevice(null, "video")
      .then((result) => {
        this.barcodeValue = result.text;
        this.barcodeChange.emit(result.text);
        this.onBlur.emit(result.text);
        this.scannerStarted = false;
        this.codeReader.reset();
        console.log("barcode: " + result);
      })
      .catch((err) => console.log(err));
  }

  blur() {
    this.onBlur.emit(this.barcodeValue);
  }

  cancel() {
    this.scannerStarted = false;
    this.codeReader.reset();
  }

  resetCodeReader() {
    this.cancel();
    this.start();
  }

  onInputChange(target) {
    this.barcodeValue = target;
    this.barcodeChange.emit(target);
  }
}
